export const CFC_ELIGIBILITY_ALERT_AUTO_OPENED_SESSION_KEY =
  "btoProviderCfcEligibilityAlertAutoOpened";
